import { invoiceMutations } from "./invoices/mutations";
import { invoiceReminderMutations } from "./invoice-reminders/mutations";
import { accountingReportMutations } from "./reports/mutations";
import { costsMutations } from "./costs/mutations";
import { AccountingModulePluginStore } from "./plugin-store";

export const mutations = {
  ...invoiceMutations,
  ...invoiceReminderMutations,
  ...accountingReportMutations,
  ...costsMutations,
  ...AccountingModulePluginStore.mutations,
};
